var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4817 27.2968L12.9191 24.251L5.07263 17.9743L12.9191 11.6975L10.4817 8.65175L0.73213 16.4514C0.50369 16.6341 0.319273 16.8658 0.192538 17.1294C0.0658041 17.393 0 17.6818 0 17.9743C0 18.2668 0.0658041 18.5555 0.192538 18.8191C0.319273 19.0827 0.50369 19.3145 0.73213 19.4971L10.4817 27.2968ZM28.5183 8.65175L26.0809 11.6975L33.9274 17.9743L26.0809 24.251L28.5183 27.2968L38.2679 19.4971C38.4963 19.3145 38.6807 19.0827 38.8075 18.8191C38.9342 18.5555 39 18.2668 39 17.9743C39 17.6818 38.9342 17.393 38.8075 17.1294C38.6807 16.8658 38.4963 16.6341 38.2679 16.4514L28.5183 8.65175ZM25.3029 0.846261L17.5033 35.9446L13.6951 35.0984L21.4948 0L25.3029 0.846261Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.ffccde1a9ff125580aeb8c1460b63d5e.svg";
export { ForwardRef as ReactComponent };